export default [
  { label: 'Excited', value: 'excited' },
  { label: 'Motivated', value: 'motivated' },
  { label: 'Happy', value: 'happy' },
  { label: 'Anxious', value: 'anxious' },
  { label: 'Overwhelmed', value: 'overwhelmed' },
  { label: 'Uninterested', value: 'uninterested' },
  { label: 'Other', value: 'other' },
];
